import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="page-container">
      <Card className="shadow-sm border-0">
        <Card.Body>
          <p className="text-muted text-uppercase small mb-2">404</p>
          <h2>Route not found</h2>
          <p className="text-secondary">The requested page could not be found.</p>
          <Button as={Link} to="/">Back to dashboard</Button>
        </Card.Body>
      </Card>
    </div>
  );
}
